import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { TicketsManagement } from '../../components/admin/TicketsManagement';

export function SupportPage() {
  return (
    <AdminLayout
      title="Support"
      description="Gérez les tickets de support client"
    >
      <TicketsManagement />
    </AdminLayout>
  );
}
